module.exports = __webpack_public_path__ + "static/1-226a4a62c374acecfd5169bc1f7bdf40.jpg";